import { render } from "./App.vue?vue&type=template&id=04404184"
const script = {}

import "./App.vue?vue&type=style&index=0&id=04404184&lang=css"

import exportComponent from "D:\\CAS Project\\ESM Web App\\master ESM-WEB\\esm-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__